import { useEffect, useState } from "react";
import styled from "styled-components";
import SellerService from "../../../services/seller.service";
import { FullReservation, ReservationPaymentList } from "../../../types/common.types";
import removeTimezone from "../../../utils/removeTimezone";
import { BsEyeFill } from "react-icons/bs";
import { BiListUl } from "react-icons/bi";
import { useSeller } from "../../../context/seller";
import { IoMdAddCircleOutline } from "react-icons/io";
import { Dispatch, SetStateAction } from "react";
// utils
import { add, format, startOfToday } from "date-fns";
// context
import { useAdmin } from "../../../context/admin";
// icons
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
// components
import CalendarDual from "../../common/CalendarDual";

export default function Payments() {
    const { setViewPaymentsData, setReservationData, setNewPassenger, setNewGroup, 
        setNewGroupReservationData, setCreatePaymentReservationId, setCreatePaymentGroupId } = useSeller()
    const [data, setData] = useState<ReservationPaymentList[]>([])
    
    return (
        <Main>
            <Filter
            setData={setData}
            />
            <TableWrapper>
                <Table>
                    <thead>
                        <th>Date</th>
                        <th>Type</th>
                        <th>Passenger</th>
                        <th>Order ID</th>
                        <th>Tour ID</th>
                        <th>Price</th>
                        <th>Tickets</th>
                        <th style={{width: '50px'}}>View</th>
                        <th style={{width: '70px'}}>Payment</th>
                        <th style={{width: '40px'}}>New</th>
                    </thead>
                    <tbody>
                        {
                            data.map((item) => {
                                const group_passengers_base = item.type === 'group' ? item.reservations.map(r => r.passenger) : []
                                // prevent duplicated passengers in group reservations
                                const passengers = item.type === 'group' ? 
                                group_passengers_base.filter((passenger, index, self) =>
                                    index === self.findIndex((p) => (
                                        p.id === passenger.id
                                    ))
                                ) : [item.passenger]

                                const reservation_tours = item.type === 'group' ?
                                item?.reservations.filter((res, index, self) =>
                                    index === self.findIndex((r) => (
                                        r.tour_id === res.tour_id
                                    ))
                                ).map(r => r.tour_id) : [item.tour_id]

                                const price = item.type === 'group' ?
                                item.reservations.map(r => r.price).reduce((a,b) => a + b, 0)
                                : item.price
                                
                                const tickets = item.type === 'group' ?
                                item.reservations.map(r => r.tickets).reduce((a,b) => a + b, 0)
                                : item.tickets


                                return (
                                    <tr>
                                        <td>{removeTimezone(item.reservation_date || item.reservations[0].reservation_date)}</td>
                                        <td>{item.type}</td>
                                        <td>{passengers[0].name}</td>
                                        <td>{item.group_id || item.id}</td>
                                        <td>{reservation_tours.map(r => <>{r}<br/></>)}</td>
                                        <td>{price}</td>
                                        <td>{tickets}</td>
                                        <td>
                                            <button
                                            onClick={() => {
                                                setReservationData(item)
                                            }}
                                            className="select">
                                                <BsEyeFill/>
                                            </button>
                                        </td>
                                        <td>
                                            <button className="select"
                                            onClick={() => {
                                                if (item.type === 'group') {
                                                    setCreatePaymentGroupId(item.group_id)
                                                } else {
                                                    setCreatePaymentReservationId(item.id)
                                                }
                                                setViewPaymentsData(item.payments)
                                            }}
                                            >
                                                <BiListUl/>
                                            </button>
                                        </td>
                                        <td>
                                            <button className="select"
                                            onClick={() => {
                                                if (item.type === 'group') {
                                                    setNewGroup(passengers)
                                                    setNewGroupReservationData({
                                                        group_id: item.group_id,
                                                    })
                                                } else {
                                                    setNewPassenger(item.passenger)
                                                }
                                            }}
                                            >
                                                <IoMdAddCircleOutline />
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>
            </TableWrapper>
        </Main>
    )
}

const Main = styled.main`
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
height: 100%;
h2 {
    font-size: 20px;
    font-weight: 500;
    color: ${props => props.theme.gray};
}
`

const TableWrapper = styled.div`
width: 100%;
overflow: auto;
min-height: 80px;
`

const Table = styled.table`
border-collapse: collapse;
position: relative;
table-layout: fixed;
height: 100%;
width: 100%;
min-width: 350px;
thead {
    width: 100%;
    background-color: #FFFFFF;
}
th {
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
}
td {
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    .flag {
        width: 30px;
    }
    button.select {
        width: 20px;
        height: 20px;
        color: #FFF;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        line-height: 40px;
        padding: 2px;
        background-color: ${props => props.theme.black};
        border: 1px solid ${props => props.theme.black};
        border-radius: 5px;
        cursor: pointer;
        transition: transform .3s ease;
        &:active {
            transform: scale(0.8);
        }
    }
    button.selected {
        background-color: ${props => props.theme.yellowDark};
    }
    button.info {
        border: none;
        background-color: none;
        font-size: 16px;
        cursor: pointer;
    }
}
tr {
    height: 40px;
    width: 100%;
}
`

function Filter({setData}: 
    {setData: Dispatch<SetStateAction<ReservationPaymentList[]>>
    }
) {
    const { currentDay, setCurrentDay, endDay, setEndDay} = useSeller()
    const [isCalendarOpen, setIsCalendarOpen] = useState(false)

    function handleCurrentDay (action: 'forwards' | 'backwards') {
        const newDate = add(currentDay, {days: action === 'backwards' ? -1 : 1} )
        setCurrentDay(newDate)
    }

    useEffect(() => {
        async function fetchData() {
            if (!currentDay) {
                setData([])
                return 
            }
            const response = await (await SellerService.getPaymentsInfo(currentDay, endDay)).data
            setData(response)
        }
        fetchData()
    }, [currentDay, endDay])

    
    return (
        <MainFilter>
            <button
                onClick={() => handleCurrentDay('backwards')}
                >
                    <IoIosArrowBack/>
                </button>
                <div className="filters">
                    <div className="date"
                    >
                        <button className="open-calendar"
                        onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                        ></button>
                        {
                            currentDay && <span 
                            >{`${format(currentDay, 'dd/MM/yyyy')} ${endDay ? '- ' + format(endDay, 'dd/MM/YYY'): ''}`}</span>
                        }
                        <div className={`calendar ${isCalendarOpen ? 'open' : ''}`}>
                            <CalendarDual
                            endDay={endDay}
                            setEndDay={setEndDay}
                            selectedDay={currentDay}
                            setSelectedDay={setCurrentDay}
                            selectPastDays
                            />
                        </div>
                    </div>
                </div>
                <button
                onClick={() => handleCurrentDay('forwards')}
                >
                    <IoIosArrowForward/>
                </button>
        </MainFilter>
    )
}

const MainFilter = styled.div`
width: 100%;
padding: 30px 0;
display: flex;
justify-content: space-around;
.filters {
    flex: 1;
    display: flex;
    justify-content: center;
    gap: 10px;
}
.filters > .dropdown {
    height: 100%;
    select {
        height: 100%;
        padding: 5px 10px;
    }
}
.filters > .date {
    padding: 20px;
    width: 70%;
    max-width: 350px;
    text-align: center;
    height: 100%;
    position: relative;
    z-index: 10;
    > button.open-calendar {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        background-color: ${props => props.theme.blueLight};
        cursor: pointer;
        border: none;
    }
    > .calendar {
        display: none;
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        &.open {
            display: initial;
        }
    }
    > span {
        color: #FFF;
        position: absolute;
        white-space: nowrap;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;
    }
}
> button {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 30px;
    border: none;
    background-color: ${props => props.theme.white};
    font-size: 16px;
    color: #000;
    box-shadow: 0 5px 3px ${props => props.theme.blackTransparent};
    transition: transform .3s ease;
    cursor: pointer;
    &:hover {
        transform: translateY(-3px);
    }
}
`